import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import './index.scss';
import Button from "../../common/Button";
import MSGDialogue from '../../components/Dialogue';
import axios from 'axios';
import { APIurl } from '../../App';

export default function ActivateUser() {
  const [msg, setMsg] = useState('');
  const [colors, setColors] = useState('');
  const [showDialog, setShowDialog] = useState(false);
  const [userId, setUserId] = useState(null);
  const [isMasterAdmin, setIsMasterAdmin] = useState(false);
useEffect(() => {
  // Get user ID from URL safely
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");
  setUserId(id);

  // Get email from localStorage
  const email = localStorage.getItem("email");

  if (email) {
    const lowerEmail = email.toLowerCase();

    if (
      lowerEmail === "belmiromohlala34@gmail.com" ||
      lowerEmail === "moropaneleago012@gmail.com"
    ) {
      setIsMasterAdmin(true);
    }
  }
}, []);


  const handleActivate = () => {
    if (!userId) {
      setMsg("User ID not found!");
      setColors("text-white bg-danger");
      setShowDialog(true);
      return;
    }

    axios.post(APIurl, { cmd: 'activateAccount', id: userId })
      .then(res => {
        const result = res.data;

        // Show server message
        setMsg(result.data || "No response message from server");
        setColors(result.success ? "text-white bg-success" : "text-white bg-danger");
        setShowDialog(true);

        if (result.success) {
          setTimeout(() => {
            window.location.href = '/adduser';
          }, 2000);
        }
      })
      .catch(err => {
        console.log(err);
        setMsg("Network error. Please try again.");
        setColors("text-white bg-danger");
        setShowDialog(true);
      });
  };

  return (
    <>
      {showDialog && <MSGDialogue msg={msg} id="activation-dialog" colors={colors} />}

      <div className='mr-0 ml-0 p-2 mt-2 mb-0'>
        <h3>Activate User Account</h3>
      </div>

      <Container fluid className='d-flex flex-row mt-2 w-100 home-cards'>
        <div className='login-container mx-auto my-3 p-3 bg-white rounded animate__animated animate__fadeInDown'>
          <div className="theme-color h3 text-center mb-3">Activate this account</div>

          {isMasterAdmin ? (
            <>
            <div className=''>
                <p>Only click the button below after the client has paid the subscription fee of R600.
                    And you have proof of payment. Please understand that by clicking the button below you 
                    giving the user full access to the app until 60 days has passed and you won't be able to reverse this action
                </p>
   <Button
              icon="fa fa-user-check"
              title="Activate this account"
              active="btn-success my-3"
              action={handleActivate}
            />
            </div>
           
            </>
          
          ) : (
            <p className="text-danger text-center">
              Please ask the Admin to activate this account for you.
            </p>
          )}
        </div>
      </Container>
    </>
  );
}
